import styled from 'styled-components';

export const StyledSelectWrapper = styled.div`
  display: flex;
`;
